export default __webpack_public_path__ + "static/media/groundskeeper.aef28ca8.png";